<template>
  <b-card>
    <!-- <b-card-body> -->
    <data-table
      :data-table="dataCampaignActivityItem"
      :field-table="dataCampaignActivityField"
      :table-for="table"
      :data-for="dataFor"
      :mutation-for="mutationFor"
      :tool="tool"
      :action="action"
      :list="list"
    >
      <template #cell(clc_date)="data">
        {{ formatDateIdr(data.value) }}
      </template>
      <template #cell(click)="data">
        <span class="text-right d-block">{{ formatPrice(data.value) }}</span>
      </template>
      <template #cell(ctr)="data">
        <span class="text-right d-block">{{ formatPrice(data.value) }}%</span>
      </template>
      <!-- <template #cell(cvr)="data">
        <span class="text-right d-block">{{ formatPrice(data.value) }}%</span>
      </template> -->
      <!-- <template #cell(mt)="data">
        <span class="text-right d-block">{{ formatPrice(data.value) }}</span>
      </template> -->
      <template #cell(impression)="data">
        <span class="text-right d-block">{{ formatPrice(data.value) }}</span>
      </template>
      <template #cell(budget_usage)="data">
        <span class="text-right d-block">{{ formatPrice(data.value) }}</span>
      </template>
    </data-table>
    <!-- </b-card-body> -->
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import DataTable from '@/views/component/DataTable.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    BCard,
    DataTable,
  },
  data() {
    return {
      table: 'campaign',
      dataFor: 'dataCampaignActivity',
      tool: false,
      mutationFor: 'ACTIVITY',
      action: false,
      list: 'getCampaignActivity',
    }
  },
  computed: {
    ...mapGetters('campaign', {
      dataCampaignActivityField: 'getCampaignActivityField',
      dataCampaignActivityItem: 'getCampaignActivityItem',
    }),
  },
  mounted() {
    this.getCampaignActivity(this.$route.params.id)
    // console.log(this.dataCampaignActivityField)
  },
  methods: {
    ...mapActions('campaign', [
      'getCampaignActivity',
    ]),
    formatDateIdr(date) {
      let dd = date.replace(/-/g, '/')
      let d = new Date(dd)
      const dt = (`0${d.getDate()}`).slice(-2)
      const month = (`0${d.getMonth() + 1}`).slice(-2)
      const year = d.getFullYear()
      return `${dt}/${month}/${year}`
    },
    formatPrice(value) {
      if (!this.isFloat(value)) {
        let val = (value / 1).toFixed(0).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      }
      return value
    },
    isFloat(n) {
      return Number(n) === n && n % 1 !== 0
    },
  },
}
</script>
